export enum AuthenticateParams {
  ACCESS_TOKEN = 'accessToken',
  USER_SUBDOMAIN = 'userSubdomain',
  ORG_ID = 'orgId'
}
